export default __webpack_public_path__ + "static/kompetenzen-65b3c55ae189d9a24e8f8dc5d32e5a59.png";